import System from "src/helper/system";
import Common from "src/pages/HomePageContent/Common";
import CommonContent from "src/pages/HomePageContent/CommonContent";
import Helper from "src/support/Helper";
import Product from "./product";

let c = System.getParams();

class HomePages {
    static DOCUMENT_CONTENT_DATA_LIST = Helper.getApplicationUrl() + '/api/application/product/documentsearch'

    static CONTENT_TAB_COUNT_NEW = Helper.getApplicationUrl() + '/api/application/webSearchContent/count'
    static ALL_CONTENT_TAB = Helper.getApplicationUrl() + '/api/application/webSearchContent'

    static getHomeTabsListRouteURL(extra_c = {}) {
        // 16933 - Need to remove trailing slash condition - PN - 16/2/2024
        c[Common.param_key] = Common.chain.HomePageContent.param_value.replace(/\/$/, "");
        return this.getURLBasedOnParamKey({
            //...c,
            ...extra_c
        });
    }

    static makeHomeTabsListRouteURL(param_value) {
        return this.getHomeTabsListRouteURL({
            //...c,
            [Common.param_key_HomeTabList]: param_value
        });
    }

    static getHomeContentTabsListRouteURL(extra_c = {}) {
        c[Common.param_key_HomeTabList] = Common.chain_HomeTabList.CNT.param_value;
        c[CommonContent.param_key] = CommonContent.chain.HomePageContentTab.param_value;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getURLBasedOnParamKey(c) {
        return Product.getProductListingPageRouteURL(c);
    }
}

export default HomePages;